
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

export const GetStarted = () => {
  const navigate = useNavigate();

  return null;
};
